import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { CartProvider } from "./contexts/CartContext";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { CartSheet } from "./components/CartSheet";
import { Toaster } from "./components/ui/sonner";
import { FloatingCallButton } from "./components/FloatingCallButton";
import { SpinWheelPopup } from "./components/SpinWheelPopup";
import { ChatWidget } from "./components/ChatWidget";

import { AIHome } from "./pages/AIHome";
import { MapHome } from "./pages/MapHome";
import { FeedHome } from "./pages/FeedHome";
import { BurgerHome } from "./pages/BurgerHome";
import { BurgerMenu } from "./pages/BurgerMenu";
import { PartnerAnalytics } from "./pages/PartnerAnalytics";
import { StoreMenu } from "./pages/StoreMenu";
import { MenuPage } from "./pages/Menu";
import { Offers } from "./pages/Offers";
import { KidsMenu } from "./pages/KidsMenu";
import { Login } from "./pages/Login";
import { Register } from "./pages/Register";
import { Checkout } from "./pages/Checkout";
import { OrderTracking } from "./pages/OrderTracking";
import { LiveOrderTracking } from "./pages/LiveOrderTracking";
import { MyOrders } from "./pages/MyOrders";
import { Admin } from "./pages/Admin";
import { AdminAnalytics } from "./pages/AdminAnalytics";
import { AdminLogin } from "./pages/AdminLogin";
import { AdminCommand } from "./pages/AdminCommand";
import { AdminMenu as AdminMenuCMS } from "./pages/AdminMenu";
import { AuthCallback } from "./pages/AuthCallback";
import { StoreDashboard } from "./pages/StoreDashboard";
import { PartnerDashboard } from "./pages/PartnerDashboard";
import { PartnerSignup } from "./pages/PartnerSignup";
import { StickyCartBar } from "./components/StickyCartBar";

// Hide chrome (navbar/footer/sticky bars/spinwheel) on the AI immersive home
const Chrome = () => {
    const { pathname } = useLocation();
    const isImmersive = pathname === "/" || pathname === "/menu" || pathname === "/marketplace" || pathname === "/map" || pathname === "/chat" || pathname.startsWith("/checkout") || pathname.startsWith("/store") || pathname.startsWith("/partner") || pathname.startsWith("/order") || pathname.startsWith("/admin");
    return (
        <>
            {!isImmersive && <Navbar />}
            {!isImmersive && <CartSheet />}
            {!isImmersive && <FloatingCallButton />}
            {!isImmersive && <ChatWidget />}
            {!isImmersive && <StickyCartBar />}
            {!isImmersive && <SpinWheelPopup />}
            {!isImmersive && <Footer />}
        </>
    );
};

function App() {
    return (
        <div className="App min-h-screen flex flex-col">
            <BrowserRouter>
                <AuthProvider>
                    <CartProvider>
                        <main className="flex-1 relative z-10 flex flex-col">
                            <Routes>
                                <Route path="/" element={<BurgerHome />} />
                                <Route path="/menu" element={<BurgerMenu />} />
                                <Route path="/marketplace" element={<FeedHome />} />
                                <Route path="/map" element={<MapHome />} />
                                <Route path="/store/:slug" element={<StoreMenu />} />
                                <Route path="/chat" element={<AIHome />} />
                                <Route path="/menu-legacy" element={<MenuPage />} />
                                <Route path="/offers" element={<Offers />} />
                                <Route path="/kids" element={<KidsMenu />} />
                                <Route path="/checkout" element={<Checkout />} />
                                <Route path="/order/:id" element={<LiveOrderTracking />} />
                                <Route path="/order-legacy/:id" element={<OrderTracking />} />
                                <Route path="/orders" element={<MyOrders />} />
                                <Route path="/login" element={<Login />} />
                                <Route path="/register" element={<Register />} />
                                <Route path="/admin" element={<Admin />} />
                                <Route path="/admin/login" element={<AdminLogin />} />
                                <Route path="/admin/command" element={<AdminCommand />} />
                                <Route path="/admin/menu" element={<AdminMenuCMS />} />
                                <Route path="/admin/analytics" element={<AdminAnalytics />} />
                                <Route path="/store" element={<StoreDashboard />} />
                                <Route path="/partner" element={<PartnerDashboard />} />
                                <Route path="/partner/signup" element={<PartnerSignup />} />
                                <Route path="/partner/analytics" element={<PartnerAnalytics />} />
                                <Route path="/auth/callback" element={<AuthCallback />} />
                            </Routes>
                        </main>
                        <Chrome />
                        <Toaster theme="dark" position="top-right" richColors />
                    </CartProvider>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
